import { notification } from "antd";
import { CloseCircleFilled } from '@ant-design/icons';
import "./notificationAlert.css"

const notificationPosition = "topRight";
const durationNotification = 3;

notification.config({
  maxCount: 1
});

export const errorNotificationAlert = (title, content, detailContent) => {
  notification.error({
    message:
      <div className="error-alert-title-style">
        {title}
      </div>,
    description:
      <>
        <div className="error-alert-content-style">{content}</div>
        <div className="error-alert-content-detail-style">{detailContent}</div>
      </>,
    icon: <CloseCircleFilled style={{ color: "rgba(203, 24, 1, 1)", fontSize: "30px"}} />,
    duration: durationNotification,
    placement: notificationPosition,
    style: {
      color: 'rgba(0, 0, 0, 0.65)',
      border: '1px solid white',
      boxShadow: '0px 4px 12px -3px rgba(0, 0, 0, 0.25)',
      backgroundColor: 'white',
      borderRadius: '10px',
      borderLeftColor: "rgba(155, 55, 137, 1)",
      borderLeftWidth: "10px",
    },
  });
}
